import { render, staticRenderFns } from "./SubMenuBar.vue?vue&type=template&id=7245dfa4&scoped=true&"
import script from "./SubMenuBar.vue?vue&type=script&lang=js&"
export * from "./SubMenuBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7245dfa4",
  null
  
)

export default component.exports